<template>
	<div ref="main" class="ceami_container" @scroll="handleScroll">

		<div class="general_back_top" v-if="isShowScrollBtn" @click="scrollToTop">
			<img class="icon" src="../../assets/image/shang.png" alt="" />
			<div>返回顶部</div>
		</div>

		<!-- 头部 -->
		<div class="ci_panel panel_1">
			<div class="ci_inner header_box" style="color: #1C417F; font-size: 28px; font-weight: 600;">
				<!-- <img class="logo" src="../../assets/images/ceami_logo.gif" alt="" /> -->
				中国机械工业教育协会
			</div>
		</div>

		<!-- 导航 -->
		<div class="ci_panel panel_2">
			<div class="ci_inner navbar_box">
				<div class="navbar_item" @click="reSelectedClick">职业能力证书查询入口</div>
			</div>
		</div>

		<!-- 查询操作区 -->
		<div class="ci_panel panel_5" v-if="page_index==1">
			<div class="ci_inner body_box" v-if="!selected">
				<div class="selected_items">
					<div class="selected_item" :class="{'actived':selected == 1}" @click="selectedClick(1)">
						<div class="selected_item_inner">
							<span>技能竞赛等级证书</span>
							<i class="el-icon-search" style="font-size: 40px;"></i>
							<el-button round size="medium" style="width: 100%;">查询</el-button>
						</div>
					</div>
					<div class="selected_item" :class="{'actived':selected == 2}" @click="selectedClick(2)">
						<div class="selected_item_inner">
							<span>团体标准能力证书</span>
							<i class="el-icon-search" style="font-size: 40px;"></i>
							<el-button round size="medium" style="width: 100%;">查询</el-button>
						</div>
					</div>
					<div class="selected_item" :class="{'actived':selected == 3}" @click="selectedClick(3)">
						<div class="selected_item_inner">
							<span>其他职业能力证书</span>
							<i class="el-icon-search" style="font-size: 40px;"></i>
							<el-button round size="medium" style="width: 100%;">查询</el-button>
						</div>
					</div>
				</div>
			</div>


			<div class="ci_inner body_box" v-if="selected">
				<div class="img_box">
					<div class="img_item">
						<img src="../../assets/images/ceami_bg.png" style="height: 440px;" />
					</div>
				</div>

				<div class="form_box">
					<div class="form_title">
						<span v-if="selected == 1">技能竞赛等级证书</span>
						<span v-if="selected == 2">团体标准能力证书</span>
						<span v-if="selected == 3">其他职业能力证书</span>
					</div>
					<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-position="top"
						label-width="200px">
						<div v-for="(domain, index) in dynamicValidateForm.domains" :key="domain.key">
							<el-form-item :prop="'domains.' + index + '.cert_number'"
								:rules="[{ required: true, message: '请输入证书编号', trigger: ['blur', 'change'] },{ min:20,max:22,message: '请输入正确的证书编号', trigger: ['blur', 'change'] }]">
								<el-input v-model="domain.cert_number" placeholder="请输入证书编号"></el-input>
							</el-form-item>

							<el-form-item :prop="'domains.' + index + '.id_number'"
								:rules="[{ required: true, message: '请输入身份证号', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号', trigger: ['blur', 'change'] }]">
								<el-input v-model="domain.id_number" placeholder="请输入身份证号"></el-input>
							</el-form-item>

							<el-form-item :prop="'domains.' + index + '.name'"
								:rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
								<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
							</el-form-item>
						</div>
					</el-form>
					<div class="btn_box" style="">
						<el-button type="primary" style="width: 100%;" @click="searchConfirm">查询</el-button>
						<Vcode :show="vcode.show" :imgs="vcode.imgs" :sliderText="vcode.sliderText" @success="onSuccess"
							@close="onClose"></Vcode>
					</div>
					<div class="note_box">
						<p class="p1">注：1、查询证书需输入姓名、证件号码、证书编号</p>
						<p class="p2">
							2、仅能查询中国机械工业教育协会颁发的职业能力证书（含职业技能等级证书），非中国机械工业教育协会颁发的证书不在本网站查询，中国机械工业教育协会是人社部门备案的评价机构，本网站查询到的证书信息与人社部门官方网站查询的信息一致。
						</p>
					</div>

					<div class="rs_link_box">
						<div class="rs_link" @click="reSelectedClick">查询其他类型证书</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 查询结果区 -->
		<div class="ci_panel panel_3" v-if="page_index==2">
			<div class="ci_inner body_box2">
				<div class="breadcrumb_box">
					<div>当前位置：</div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item><a @click="requeryClick">证书查询</a></el-breadcrumb-item>
						<el-breadcrumb-item><span>查询结果</span></el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="cert_info_title">
					查询结果
				</div>
				<div class="cert_info_container">
					<div v-if="!list || (list && list.count ==0 )" class="cert_info_empty">
						<div class="message"><img src="../../assets/images/ceami_icon_empty.png"
								class="icon_empty" />抱歉，没有查询到相关信息</div>
						<div class="s_line"></div>
						<div class="question">
							<div class="question_title">该怎么办？</div>
							<div class="answer_items">
								<div class="answer_item">
									1、本网站仅提供由中国机械工业教育协会颁发的职业能力证书（含职业技能等级证书）查询服务，其他评价机构颁发的职业技能等级证书不在本网站查询。如需查询人社部门备案的其他评价机构颁发的职业技能等级证书，建议前往
									<a href="https://jndj.osta.org.cn/" target="_blank"
										class="c_link">技能人才评价证书全国联网查询系统</a>
									查询。
								</div>
								<div class="answer_item">2、输入的信息有误，<a class="c_link" @click="requeryClick">回到证书查询首页</a>
									重新填写信息后再次查询。</div>
								<div class="answer_item">3、其他证书相关问题请联系中国机械工业教育协会秘书处：010-88379175。</div>
							</div>
						</div>
					</div>
					<div class="cert_info_items" v-if="list && list.length >0 ">
						<div class="cert_info_item" v-for="(item,index) in list">
							<div class="cert_info_item-title">
								<div class="text">
									证书{{index+1}}
								</div>
							</div>
							<div class="cert_info_item-content">
								<div class="info_left">
									<div>基础信息</div>
									<div class="info_list">
										<div class="info">
											<div class="info_lable">姓名</div>
											<div class="info_value">{{item.name}}</div>
										</div>
										<div class="info" v-if="item.sex">
											<div class="info_lable">性别</div>
											<div class="info_value">{{item.sex}}</div>
										</div>
										<div class="info">
											<div class="info_lable">证件类型</div>
											<div class="info_value">{{item.id_type}}</div>
										</div>
										<div class="info">
											<div class="info_lable">证件号码</div>
											<div class="info_value">{{item.id_number}}</div>
										</div>
									</div>
								</div>
								<div class="info_right">
									<div>证书信息</div>
									<div class="info_list">
										<div class="info">
											<div class="cell">
												<div class="info_lable">职业名称</div>
												<div class="info_value">{{item.vocation}}</div>
											</div>
											<div class="cell">
												<div class="info_lable">
													<span v-if="item.cert_type == 1">工种名称</span>
													<span v-if="item.cert_type == 2">职业方向</span>
												</div>
												<div class="info_value">{{item.job}}</div>
											</div>
										</div>
										<div class="info">
											<div class="cell">
												<div class="info_lable">职业技能等级</div>
												<div class="info_value">{{item.level}}</div>
											</div>
											<div class="cell">
												<div class="info_lable">证书编号</div>
												<div class="info_value">{{item.cert_number}}</div>
											</div>
										</div>
										<div class="info" v-if="item.testing_authority || item.issuing_authority">
											<div class="cell">
												<div class="info_lable">评价机构</div>
												<div class="info_value">{{item.testing_authority}}</div>
											</div>
											<div class="cell">
												<div class="info_lable">发证机构</div>
												<div class="info_value">{{item.issuing_authority}}</div>
											</div>
										</div>
										<div class="info"
											v-if="item.theoretical_evaluation_result || item.practical_evaluation_result">
											<div class="cell">
												<div class="info_lable">
													<span>理论25学时</span>
													<span>（考评结果）</span>
												</div>
												<div class="info_value">{{item.theoretical_evaluation_result}}</div>
											</div>
											<div class="cell">
												<div class="info_lable">
													<span>实操35学时</span>
													<span>（考评结果）</span>
												</div>
												<div class="info_value">{{item.practical_evaluation_result}}</div>
											</div>
										</div>
										<div class="info" v-if="item.evaluation_basis">
											<div class="cell">
												<div class="info_lable">评价依据</div>
												<div class="info_value info_value2">{{item.evaluation_basis}}</div>
											</div>
										</div>
										<div class="info"
											v-if="item.cert_type == 2 && (item.evaluation_platform || item.implementing_authority)">
											<div class="cell">
												<div class="info_lable">评价系统</div>
												<div class="info_value">{{item.evaluation_platform}}</div>
											</div>
											<div class="cell">
												<div class="info_lable">
													<span>团体标准</span>
													<span>实施机构</span>
												</div>
												<div class="info_value">{{item.implementing_authority}}</div>
											</div>
										</div>
										<div class="info">
											<div class="cell">
												<div class="info_lable">发证日期</div>
												<div class="info_value">{{item.issue_at}}</div>
											</div>
											<div class="cell">
												<div class="info_lable"></div>
												<div class="info_value"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="service" v-if="list && list.length >0 ">
						<div>以上查询服务由中国机械工业教育协会提供</div>
						<div class="link" @click="requeryClick">回到证书查询首页</div>
					</div>
				</div>
			</div>
		</div>

		<div class="ci_panel" style="background-color: #fff;">
			<div class="ci_inner footer_box">
				<div>
					<div>版权所有：中国机械工业教育协会</div>
					<div>Copyright©2025 All rights reserved</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	import Vcode from "vue-puzzle-vcode";

	export default {
		data() {
			return {
				page_index: 1,
				vcode: {
					show: false,
					sliderText: '向右拖动滑块完成拼图',
					imgs: [
						require('@/assets/images/vcode/img0.jpg'),
						require('@/assets/images/vcode/img1.jpg'),
						require('@/assets/images/vcode/img2.jpg'),
						require('@/assets/images/vcode/img3.jpg'),
						require('@/assets/images/vcode/img4.jpg'),
						require('@/assets/images/vcode/img6.jpg')
					]
				},
				isShowScrollBtn: false,
				dynamicValidateForm: {
					domains: [{
						cert_number: '',
						id_number: '',
						name: '',
					}]
				},
				list: null,
				selected: null,
			};
		},
		components: {
			Vcode
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		created() {
			document.title = "CEAMI - 中国机械工业教育协会";
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				if (vm.isMobilePhone()) {
					window.location.href = 'https://m.cmptt.com/pages/exts/ceami';
				}
			});
		},
		methods: {
			isMobilePhone() {
				const ua = navigator.userAgent.toLowerCase();
				const t1 =
					/android|webos|iphone|ipod|blackberry|iemobile|opera mini|opera mobile|applewebkit.*mobile|mobile/i
					.test(ua);
				return t1;
			},
			reSelectedClick() {
				this.selected = null;
			},
			selectedClick(index) {
				this.selected = index;
			},
			requeryClick() {
				this.page_index = 1;
				this.list = null;
			},
			onSuccess() {
				this.vcode.show = false;
				this.getList();
			},
			onClose() {
				this.vcode.show = false;
			},
			searchConfirm() {
				var that = this;
				that.$refs['dynamicValidateForm'].validate((valid) => {
					if (valid) {
						that.vcode.show = true;
					}
				});
			},
			getList() {
				var that = this;
				var url = apiUrl.tt_osta_cert_list_get;
				var parm = {
					name: this.dynamicValidateForm.domains[0].name,
					id_number: this.dynamicValidateForm.domains[0].id_number,
					cert_number: this.dynamicValidateForm.domains[0].cert_number,
					page_index: 1,
					page_size: 100,
					order_by: '',
					client_type: 1
				};
				this.Ajax(url, parm, (data, code) => {
					if (data) {
						that.list = data.list;
						console.log(JSON.stringify(that.list))

					}
					that.page_index = 2;
					that.dynamicValidateForm.domains[0].name = '';
					that.dynamicValidateForm.domains[0].id_number = '';
					that.dynamicValidateForm.domains[0].cert_number = '';
				});
			},
			handleScroll(e) {
				let scrollY = e.target.scrollTop;
				console.log(scrollY)
				this.isShowScrollBtn = scrollY > 200;
			},
			scrollToTop() {
				this.$refs.main.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}
		},
	};
</script>

<style lang="scss" scoped>
	.ceami_container {
		width: 100%;
		height: 100vh;
		overflow: auto;
		background: #F1F1F1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		$ceami-color-index: #1768A9;

		.general_back_top {
			width: 80px;
			height: 80px;
			background: #000000;
			border-radius: 8px;
			border-radius: 8px;
			opacity: 0.3;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: fixed;
			bottom: 90px;
			right: 70px;
			cursor: pointer;
			z-index: 2000;
			font-size: 12px;
			color: #fff;

			.icon {
				width: 32px;
				height: auto
			}
		}


		.ci_panel {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			&.panel_1 {
				background-color: #fff;
			}

			&.panel_2 {
				background-color: $ceami-color-index;
			}

			&.panel_3 {
				background-color: #F1F1F1;
			}


			&.panel_4 {
				background-color: #F9FAFF;
				width: 100%;
				background-image: url('../../assets/images/ceami_bg2.png');
				background-size: 100% 100%;
				position: relative;
			}

			&.panel_5 {
				background-color: #F9FAFF;
				width: 100%;
				background-image: url('../../assets/images/ceami_bg.png');
				position: relative;
			}

			.ci_inner {
				width: 1200px;

				&.footer_box {
					height: 130px;
					color: #000;
					font-size: 14px;
					line-height: 1.5;
					padding: 20px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
				}

				&.navbar_box {
					height: 48px;
					box-sizing: border-box;
					display: flex;
					align-items: center;

					.navbar_item {
						width: 20%;
						height: 48px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						color: #fff;
						box-sizing: border-box;
						cursor: pointer;
					}
				}

				&.body_box2 {
					font-size: 14px;
					line-height: 1;
					color: #333;
					min-height: calc(100vh - 275px);
					padding: 28px 0 10px 0;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;

					.breadcrumb_box {
						display: flex;
						justify-items: center;
						align-items: center;
						font-size: 14px;
						margin-bottom: 28px;

						/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner,
						.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
						.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
						.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
							color: #1E222A !important;
						}

						/deep/.el-breadcrumb__inner a,
						.el-breadcrumb__inner.is-link {
							color: #4D5868 !important;
						}

						/deep/.el-breadcrumb__inner a:hover,
						.el-breadcrumb__inner.is-link:hover {
							color: $ceami-color-index !important;
							background-color: #E9F5FF;

						}

					}

					.cert_info_title {
						margin-bottom: 28px;
						border-left: 4px solid #1768A9;
						padding-left: 12px;
						line-height: 1.2;
						font-weight: 600;
					}

					.cert_info_container {
						width: 100%;
						background-color: #fff;
						padding: 20px;
						box-sizing: border-box;
						flex: 1;
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.cert_info_empty {
							width: 700px;
							margin: 20px auto;
							background-color: #f4f5f7;
							padding: 0 4px;
							box-sizing: border-box;
							font-weight: 700;

							.message {
								display: flex;
								align-items: center;
								color: #666;
								padding: 6px 45px;

								.icon_empty {
									width: 25px;
									margin-right: 12px;
								}
							}

							.s_line {
								width: 100%;
								height: 1px;
								background-color: #15161a;
								margin: 0;
								padding: 0;
							}

							.question {
								width: 100%;
								padding: 20px 45px;
								box-sizing: border-box;
								display: flex;
								flex-direction: column;

								.question_title {
									color: #E42D2D;
									margin-bottom: 10px;
								}

								.answer_items {
									color: #666;
									line-height: 1.75;

									.answer_item {
										margin-bottom: 10px;

										.c_link {
											color: #1768A9;
											text-decoration: underline;
											cursor: pointer;
										}
									}
								}
							}
						}

						.service {
							margin: 28px 0;
							font-size: 15px;
							font-weight: 600;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;


							.link {
								cursor: pointer;
								color: #1768A9;
								font-weight: 600;
								margin-top: 12px;
								border-bottom: 1px solid #fff;
								//text-decoration: underline;

								&:hover {
									color: #1768A9 !important;
									background-color: #E9F5FF;
								}
							}

						}

						.cert_info_items {
							display: flex;
							flex-direction: column;

							.cert_info_item {
								display: flex;
								flex-direction: column;

								.cert_info_item-title {
									.text {
										display: flex;
										align-items: center;
										justify-content: center;
										width: 4em;
										height: 20px;
										font-size: 12px;
										background-color: #e9f5ff;
										border: 1px solid #1768A9;
									}
								}

								.cert_info_item-content {
									display: flex;
									flex-direction: row;
									justify-content: space-between;

									.info_left {
										margin-right: 56px;
										margin-top: 24px;

										.info_list {
											border: 1px solid #e5e7eb;
											margin-top: 16px;

											.info {
												display: flex;
												border-top: 1px solid #e5e7eb;

												&:first-child {
													border-top: none;
												}

												.info_lable {
													width: 120px;
													height: 56px;
													padding: 9px 16px;
													display: flex;
													flex-direction: column;
													justify-content: center;
													align-items: center;
													box-sizing: border-box;
												}

												.info_value {
													width: 185px;
													height: 56px;
													padding: 9px 16px;
													display: flex;
													justify-content: flex-start;
													align-items: center;
													border-left: 1px solid #e5e7eb;
													box-sizing: border-box;
												}
											}
										}
									}

									.info_right {
										margin-top: 24px;

										.info_list {
											border: 1px solid #e5e7eb;
											margin-top: 16px;

											.info {
												display: flex;
												border-top: 1px solid #e5e7eb;

												&:first-child {
													border-top: none;
												}

												.cell {
													display: flex;
													border-left: 1px solid #e5e7eb;

													&:first-child {
														border-left: none;
													}

													.info_lable {
														width: 120px;
														height: 56px;
														padding: 9px 16px;
														display: flex;
														flex-direction: column;
														justify-content: center;
														align-items: center;
														box-sizing: border-box;
													}

													.info_value {
														width: 280px;
														height: 56px;
														padding: 9px 16px;
														display: flex;
														justify-content: flex-start;
														align-items: center;
														border-left: 1px solid #e5e7eb;
														box-sizing: border-box;

														&.info_value2 {
															width: 680px !important;
														}
													}
												}
											}
										}
									}
								}
							}

						}
					}
				}


				&.body_box {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					padding: 30px 0;
					box-sizing: border-box;
					min-height: calc(100vh - 275px);

					.selected_items {
						width: 100%;
						height: 100%;
						display: flex;
						justify-content: space-between;

						.selected_item {
							width: 33%;
							height: 100%;
							box-sizing: border-box;
							border: 1px solid #1768a9;
							border-radius: 8px;
							background: linear-gradient(180deg, #edf7ff 0%, #fff 27.87%);
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							cursor: pointer;
							margin-right: 30px;

							.selected_item_inner {
								width: 68%;
								height: 42%;
								font-weight: 700;
								font-size: 30px;
								display: flex;
								flex-direction: column;
								justify-content: space-around;
								align-items: center;
							}

							&:last-of-type {
								margin-right: 0 !important;
							}

							&:hover,
							&.actived {
								border: 2px solid #1768a9;
								color: #1768a9;
								box-shadow: 0 2px 4px rgba(23, 104, 169, 0.12);

								.el-button {
									background: #1768a9;
									border: 1px solid #1768a9;
									color: #fff;
								}
							}
						}
					}

					.img_box {
						width: 580px;
						padding: 0 0 32px 0;
						box-sizing: border-box;

						.img_item {
							display: flex;
							justify-content: center;
							align-items: center;
						}
					}

					.form_box {
						width: 560px;
						padding: 32px;
						box-sizing: border-box;
						border: 1px solid #1768a9;
						border-radius: 8px;
						background: linear-gradient(180deg, #edf7ff 0%, #fff 27.87%);

						.form_title {
							margin-bottom: 28px;
							font-size: 18px;
							font-weight: 600;
							color: #1768a9;
						}

						.btn_box {
							margin-bottom: 28px;
						}

						.note_box {
							padding-left: 2em;
							font-size: 12px;
							line-height: 1.75;
							color: #1768A9;
							text-align: justify;

							.p1 {
								text-indent: -2em;
							}

							.p2 {
								text-indent: -1.5em;
								padding-left: 1.5em;
							}
						}

						.rs_link_box {
							margin: 28px 0;
							font-size: 15px;
							font-weight: 600;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;

							.rs_link {
								cursor: pointer;
								color: #C0C4CC;
								font-weight: 600;
								margin-top: 12px;
								border-bottom: 1px solid #C0C4CC;

								&:hover {
									color: #1768A9 !important;
									background-color: #E9F5FF;
								}
							}
						}

						/deep/.el-input__inner {
							background-color: #F2F3F5 !important;
							height: 40px !important;
							line-height: 40px !important;
						}

						/deep/.el-input__inner:focus {
							border: 1px solid $ceami-color-index;
							/* 激活时边框颜色 */
							box-shadow: 0 0 5px rgba(64, 158, 239, 0.5);
							/* 可选：添加一些阴影效果 */
						}

						/deep/.el-form-item {
							margin-bottom: 28px !important;
						}

						/deep/.el-button--primary {
							background-color: $ceami-color-index;
							border: $ceami-color-index;
						}

						/deep/.el-button--primary:hover {
							color: #fff;
							background-color: #3683BA;
							border-color: transparent;
						}

						/deep/.vue-auth-box_ .auth-control_ .range-box .range-slider {
							background-color: #1768A9 !important;
						}
					}


				}

				&.header_box {
					height: 97px;
					display: flex;
					flex-direction: column;
					justify-content: center;

					.logo {
						height: 80px;
						width: 600px;
					}
				}
			}
		}
	}
</style>